import { EventList } from "../components/EventsList";
import AnnouncementsList from "../components/AnnouncementsList";
import { socialMedia } from "../config";
import { useState, useEffect } from "react";

export default function Home() {
  const [facebookError, setFacebookError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Debug: Log the config to see what we're getting
  console.log('Facebook config:', socialMedia);

  // Add a timeout to prevent infinite loading
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (isLoading) {
        console.log('Facebook embed timeout - setting error state');
        setFacebookError(true);
        setIsLoading(false);
      }
    }, 10000); // 10 second timeout

    return () => clearTimeout(timeout);
  }, [isLoading]);

  // Generate Facebook embed URL with proper encoding and responsive parameters
  const generateFacebookEmbedUrl = (pageUrl) => {
    // Clean the URL - remove trailing slash if present
    const cleanUrl = pageUrl.replace(/\/$/, '');
    const encodedUrl = encodeURIComponent(cleanUrl);
    
    // Try a simpler approach first
    const params = new URLSearchParams({
      href: cleanUrl,
      tabs: 'timeline',
      width: '500',
      height: '600',
      small_header: 'false',
      adapt_container_width: 'true',
      hide_cover: 'false',
      show_facepile: 'true',
      appId: '' // Sometimes Facebook requires an app ID
    });
    
    const finalUrl = `https://www.facebook.com/plugins/page.php?${params.toString()}`;
    console.log('Generated Facebook URL:', finalUrl);
    console.log('Original page URL:', pageUrl);
    return finalUrl;
  };

  const handleFacebookError = () => {
    console.log('Facebook iframe error occurred');
    setFacebookError(true);
    setIsLoading(false);
  };

  const handleFacebookLoad = () => {
    console.log('Facebook iframe loaded successfully');
    setIsLoading(false);
    // Hide loading placeholder when iframe loads
    const loading = document.getElementById('facebook-loading');
    if (loading) loading.style.display = 'none';
  };

  return (
    <div className="container py-3">

      {/* Announcements Section */}
      <AnnouncementsList/>

      <div className="row g-4">
        {/* Events Section */}
        <div className="col-12 col-lg-6">
          <h2>Events</h2>
          <EventList showPast={false} />
        </div>

        {/* Facebook Section */}
        {socialMedia?.showFacebookFeed && socialMedia?.facebookPageUrl && (
          <div className="col-12 col-lg-6">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2>Latest from Facebook</h2>
            </div>
            
            <div className="position-relative w-100">
              {facebookError ? (
                <div className="card shadow-sm border-0" style={{ height: '600px' }}>
                  <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
                    <div className="mb-3">
                      <i className="fab fa-facebook fa-3x text-primary"></i>
                    </div>
                    <h5 className="card-title">Facebook Feed Unavailable</h5>
                    <p className="card-text text-muted mb-3">
                      Unable to load the Facebook feed at this time.
                    </p>
                    <a 
                      href={socialMedia.facebookPageUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      <i className="fab fa-facebook me-2"></i>
                      Visit Our Facebook Page
                    </a>
                  </div>
                </div>
              ) : (
                <>
                  {/* Loading placeholder */}
                  {isLoading && (
                    <div 
                      className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-light"
                      style={{ zIndex: 1, borderRadius: "8px" }}
                      id="facebook-loading"
                    >
                      <div className="text-center">
                        <div className="spinner-border text-primary mb-2" role="status">
                          <span className="visually-hidden">Loading Facebook feed...</span>
                        </div>
                        <p className="text-muted">Loading Facebook feed...</p>
                      </div>
                    </div>
                  )}
                  
                  <iframe
                    src={generateFacebookEmbedUrl(socialMedia.facebookPageUrl)}
                    width="100%"
                    height="600"
                    style={{ 
                      border: "none", 
                      overflow: "hidden",
                      borderRadius: "8px",
                      position: "relative",
                      zIndex: 2
                    }}
                    scrolling="no"
                    frameBorder="0"
                    allowFullScreen={true}
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    title="Facebook Page Feed"
                    onLoad={handleFacebookLoad}
                    onError={handleFacebookError}
                  />
                </>
              )}
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
